const SvgFacebook = () => (
	<svg width="1em" height="1em" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			strokeWidth={2}
			d="M5.05 27V15.811H1v-4.783h4.05c0-5.082 0-11.36 9.95-9.78v4.143c-4.308-.47-4.739.897-4.739 5.637H15l-.948 4.783h-3.79V27"
		/>
	</svg>
)

export default SvgFacebook
